import React from "react";
import { Paper, PaperProps, styled } from "@mui/material";
import { breakpointValues, customBreakpoints } from "../../styles/breakpoints";
import { detailsBarMaxWidth } from "../../styles/theme";

export const DetailBarPaper = styled(Paper)(({ theme }) => ({
  overflowY: "auto",
  backgroundColor: theme.palette.background.paper,
  borderBottom: 1,
  borderLeft: 0,
  boxShadow: "none",
  height: "100%",
  maxWidth: "100%",
  [customBreakpoints.up(breakpointValues.lg)]: {
    maxWidth: `${detailsBarMaxWidth}px`,
  },
})) as React.ComponentType<PaperProps>;
